import { render } from "./BlogStyleOne.vue?vue&type=template&id=130d04d0"
import script from "./BlogStyleOne.vue?vue&type=script&lang=js"
export * from "./BlogStyleOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__